// extracted by mini-css-extract-plugin
export default {"textButton":"Tag_textButton__izu+L","icons":"Tag_icons__-jtFv","base":"Tag_base__KmkRM","default":"Tag_default__GplK8","disable":"Tag_disable__KyX4y","primary":"Tag_primary__5beK0"};